<template>
  <div id="bulk-feeding">
    <b-container>
      <div id="feeding-form">
        <h4 class="subtitle mt-4">Students' Feeding</h4>
        <b-button
          variant="primary"
          v-if="showTable === false && isAdmin || isSRC"
          class="mt-2"
          @click="
            (showTable = !showTable), (showForm = !showForm), loadStudents()
          "
          >Add Feeding Record</b-button
        >
        <b-row
          v-if="showForm === true || buttonTitle === 'Edit Feeding Records'"
        >
          <b-col md="auto">
            <label for="feeding_date">Date</label>
            <b-form-input
              name="feeding-date"
              type="date"
              v-model="date"
              @change="dateUpdate($event)"
            ></b-form-input>
            <p class="err" v-if="!dateError">Please enter a date.</p>
          </b-col>
        </b-row>
        <b-form-group class="m-4" v-if="showTable === true">
          <div id="new-feeding">
            <label for="new-feeding">{{ tableTitle }}</label>
            <b-table
              v-cloak
              responsive
              :fields="newFeedingFields"
              :items="oneDateFeeding"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
            >
              <template slot="cell(category)" slot-scope="row">
                <b-form-group
                  :id="row.item.id.toString()"
                  :value="row.item.category"
                >
                  <b-form-checkbox-group
                    :id="row.index.toString()"
                    :options="categoryOptions"
                    name="category"
                    v-model="row.item.category"
                    @change="updateStudentFeeding($event, row.item)"
                  ></b-form-checkbox-group>
                </b-form-group>
              </template>
            </b-table>
          </div>
          <b-button
            variant="primary"
            class="m-2"
            @click="
              (showTable = !showTable),
                (showForm = !showForm),
                addBulkStudentFeeding()
            "
            >{{ buttonTitle }}</b-button
          >
          <b-button
            variant="danger"
            class="m-2"
            @click="(showTable = !showTable), (showForm = !showForm)"
            >Cancel</b-button
          >
        </b-form-group>
        <b-row>
          <b-form-group class="right m-4">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <div id="alerts" ref="feeding-alert">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="success"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
              >You have successfully added an feeding record!</b-alert
            >
            <b-alert :show="showError" dismissible variant="warning">
              Something went wrong. Please refresh and try again, or contact the
              site admin.
            </b-alert>
          </div>
          <b-table
            v-cloak
            v-if="cleanedSummaryTable.length"
            responsive
            :fields="feedingSummaryFields"
            :items="cleanedSummaryTable"
            :striped="true"
            :bordered="true"
            :hover="true"
            stacked="md"
            small
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="cell(edit)" slot-scope="row">
              <b-link
                class="edit"
                v-if="isAdmin || isSRC"
                @click.stop="(showForm = !showForm), editFeedingDate(row.item)"
                >EDIT</b-link
              >
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import FeedingService from "@/services/FeedingService";
import { flash } from "@/mixins/flashes";
import { scrollTo } from "@/mixins/scrollTo";

export default {
  name: "BulkFeeding",
  mixins: [flash, scrollTo],
  data() {
    return {
      buttonTitle: "Add Feeding Records",
      date: "",
      categoryOptions: [
        "Snack - parent",
        "Snack - school",
        "Meal - parent",
        "Meal - school",
        "Not present",
        "Not fed",
      ],
      newFeedingFields: [
        { key: "student_name", label: "Student", sortable: true },
        { key: "category", label: "Feeding Category", sortable: false },
      ],
      options: [true],
      feedingSummaryFields: [
        { key: "feeding_date", label: "Date", sortable: true },
        {
          key: "snack_parent",
          label: "Snacks - Parent",
          sortable: true,
        },
        {
          key: "snack_school",
          label: "Snacks - School",
          sortable: true,
        },
        {
          key: "meal_parent",
          label: "Meals - Parent",
          sortable: true,
        },
        {
          key: "meal_school",
          label: "Meals - School",
          sortable: true,
        },
        {
          key: "not_present",
          label: "Not present",
          sortable: true,
        },
        {
          key: "not_fed",
          label: "Not fed",
          sortable: true,
        },
        { key: "edit", label: "EDIT" },
      ],
      newStudentFeeding: [],
      filter: "",
      showTable: false,
      showForm: false,
      currentPage: 1,
      perPage: 20,
    };
  },
  methods: {
    ...mapActions({
      GET_SUMMARY_TABLE: "feedings/GET_FEEDING_SUMMARY_TABLE",
      GET_OPTIONS: "optionsList/GET_OPTIONS",
      GET_ONE_DATE_FEEDING: "feedings/GET_ONE_DATE_FEEDING",
      ADD_BULK_FEEDING: "feedings/ADD_BULK_FEEDING",
      BULK_UPDATE_ALL: "feedings/BULK_UPDATE_ALL",
    }),
    ...mapMutations("feedings/oneDateFeeding", "feedings/bulkAddDate"),
    clearForm() {
      Object.assign(this.$data, initialState());
    },
    loadStudents() {
      // set an empty array
      // bring in students from teacherStudents
      let students = this.$store.state.teachers.teacherStudents;
      // get student_id, name, present and month/year/total_days
      students = students.map((key) => ({
        id: 0,
        student_uuid: key.student_uuid,
        student_name: `${key.first_name} ${key.last_name}`,
        category: [],
        feeding_date: "",
      }));
      this.newStudentFeeding = students;
      this.$store.commit("feedings/oneDateFeeding", students);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async dateUpdate(event) {
      await this.$store.commit("feedings/bulkAddDate", event);

      if (this.buttonTitle !== "Add Feeding Records") {
        await this.BULK_UPDATE_ALL();
        await this.GET_SUMMARY_TABLE();
        await this.GET_ONE_MONTH_FEEDING({
          teacherId: parseInt(this.$route.params.id),
          date,
        });
      } else {
      }
    },
    async addBulkStudentFeeding() {
      if (this.buttonTitle === "Add Feeding Records") {
        await this.ADD_BULK_FEEDING();
      } else {
        this.buttonTitle = "Add Feeding Records";
      }
      this.date = "";
      await this.GET_SUMMARY_TABLE();
    },
    async updateStudentFeeding(event, row) {
      if (this.date === "") {
        alert("Please add a date");
        return;
      }
      const payload = {
        id: row.id,
        student_uuid: row.student_uuid,
        category: event,
        date: this.date,
      };
      if (this.buttonTitle === "Edit Feeding Records") {
        await FeedingService.updateFeedingRecords(payload);
      } else {
        return;
      }
      await this.GET_SUMMARY_TABLE();
    },
    async editFeedingDate(row) {
      this.buttonTitle = "Edit Feeding Records";
      const date = row.feeding_date;

      await this.GET_ONE_DATE_FEEDING({
        teacherId: this.$route.params.id,
        date,
      });
      this.showTable = true;
      this.date = date;
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),

    totalRows() {
      if (this.summaryTable.length > 0) {
        return this.summaryTable.length;
      }
    },
    oneDateFeeding: {
      get() {
        return this.$store.state.feedings.oneDateFeeding;
      },
    },
    summaryTable: {
      get() {
        return this.$store.state.feedings.feedingSummaryTable;
      },
    },
    cleanedSummaryTable() {
      return this.summaryTable.map((item) => {
        item.meal_parent = parseInt(item.meal_parent);
        item.snack_parent = parseInt(item.snack_parent);
        item.meal_school = parseInt(item.meal_school);
        item.snack_school = parseInt(item.snack_school);
        item.not_present = parseInt(item.not_present);
        item.not_fed = parseInt(item.not_fed);
        return item;
      });
    },
    dateError() {
      return this.date.length;
    },
    tableTitle() {
      return this.buttonTitle === "Add Feeding Records"
        ? "New Feeding Record"
        : `Edit Feeding from ${this.date}`;
    },
  },
  mounted() {
    this.GET_SUMMARY_TABLE();
    this.GET_OPTIONS();
  },
};
</script>

<style scoped>
.err {
  color: red;
  text-emphasis: italic;
}
.right {
  float: right;
}
</style>
